import React from 'react';

interface GoogleDriveIconProps {
  width?: string;
  height?: string;
}

const GoogleDriveIcon: React.FC<GoogleDriveIconProps> = ({ width = "24px", height = "24px" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_890_391)">
        <path d="M9.11093 0H18.8453L28 15.6H18.2437L9.11093 0Z" fill="url(#paint0_linear_890_391)"/>
        <path d="M28 15.6001L23.1219 23.9352H4.85625L9.74531 15.6001H28Z" fill="url(#paint1_linear_890_391)"/>
        <path d="M4.85625 23.9351L0 15.6L9.11094 0L14 8.35676L4.85625 23.9351Z" fill="url(#paint2_linear_890_391)"/>
        <path opacity="0.1" d="M4.85625 23.9352L13.9453 15.6001H9.74531L4.85625 23.9352Z" fill="black"/>
        <path opacity="0.1" d="M28 15.6001H18.2547L16.1109 11.946L28 15.6001Z" fill="black"/>
        <path opacity="0.1" d="M9.11093 0L11.9219 11.8919L14 8.35676L9.11093 0Z" fill="black"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_890_391" x1="9.11093" y1="0" x2="1540.99" y2="1854.86" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F6C338"/>
          <stop offset="0.522782" stopColor="#FFD351"/>
          <stop offset="1" stopColor="#F6C338"/>
        </linearGradient>
        <linearGradient id="paint1_linear_890_391" x1="2319.23" y1="15.6001" x2="1787.79" y2="1491.23" gradientUnits="userSpaceOnUse">
          <stop stopColor="#286EE6"/>
          <stop offset="0.521046" stopColor="#4286FB"/>
          <stop offset="1" stopColor="#286EE6"/>
        </linearGradient>
        <linearGradient id="paint2_linear_890_391" x1="914.05" y1="-5.0732e-05" x2="-126.538" y2="2077.76" gradientUnits="userSpaceOnUse">
          <stop stopColor="#069B5A"/>
          <stop offset="0.531031" stopColor="#11AA62"/>
          <stop offset="1" stopColor="#069B5A"/>
        </linearGradient>
        <clipPath id="clip0_890_391">
          <rect width="28" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default GoogleDriveIcon;
